import React from 'react';
import A11ySvg from 'components/A11ySvg';
import './AddMediaIcon.css';

function AddMediaIcon({ className, size, alt, label }) {
  const setClassName = `add-media-icon ${className || ''} ${size || ''}`;
  return (
    <span className={setClassName}>
      <A11ySvg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="463 961 30.971 26.399"
        alt={alt}
      >
        <g data-name="Group 1698" transform="translate(463 961)">
          <path
            data-name="Path 4180"
            className="fill"
            d="M16.96,20.647H2.95V2.95H25.072v9.586a6.713,6.713,0,0,1,2.95.737V0H0V23.6H17.7A6.713,6.713,0,0,1,16.96,20.647Z"
          />
          <circle
            data-name="Ellipse 61"
            className="fill"
            cx="2.95"
            cy="2.95"
            r="2.95"
            transform="translate(16.223 4.424)"
          />
          <path
            data-name="Path 4181"
            className="fill"
            d="M19.96,10.424,17.748,8.95l-4.424,1.475L7.424,6,3,8.95v7.374H15.683A7.236,7.236,0,0,1,19.96,10.424Z"
            transform="translate(1.424 2.849)"
          />
          <path
            data-name="Path 4182"
            className="fill"
            d="M18.794,9.5a6.194,6.194,0,1,0,6.194,6.194A6.232,6.232,0,0,0,18.794,9.5Zm3.245,6.932H19.384v2.655H17.909V16.432H15.255V14.957h2.655V12.3h1.475v2.655h2.655Z"
            transform="translate(5.982 4.511)"
          />
        </g>
      </A11ySvg>
      {label && <span className="add-media-label">{label}</span>}
    </span>
  );
}

export default AddMediaIcon;
